// Default tag images and configurations for community posts
// These will be used when users don't upload their own images

export const DEFAULT_TAG_CONFIG = {
  'Announcement': {
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#667eea',
    icon: '📢'
  },
  'Mazal Tov': {
    gradient: 'linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%)',
    color: '#56ab2f',
    icon: '🎉'
  },
  'Update': {
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    color: '#4facfe',
    icon: '🔄'
  },
  'News': {
    gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
    color: '#ff9a9e',
    icon: '📰'
  },
  'Chesed': {
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    color: '#a8edea',
    icon: '🤝'
  },
  'Tehilim': {
    gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    color: '#ffecd2',
    icon: '🕊️'
  },
  'Event': {
    gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    color: '#43e97b',
    icon: '🎪'
  },
  'Prayer Request': {
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    color: '#fa709a',
    icon: '🙏'
  },
  'Community': {
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    color: '#a8edea',
    icon: '👥'
  },
  'Torah': {
    gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    color: '#ffecd2',
    icon: '📜'
  },
  'default': {
    gradient: 'linear-gradient(135deg, #e0c3fc 0%, #9bb5ff 100%)',
    color: '#e0c3fc',
    icon: '💬'
  }
};

export const getTagConfig = (tag) => {
  const config = DEFAULT_TAG_CONFIG[tag] || DEFAULT_TAG_CONFIG.default;
  return config;
};

export const getDefaultImageUrl = (tag) => {
  return null;
};

export const getTagGradient = (tag) => {
  const config = getTagConfig(tag);
  return config.gradient;
};

export const getTagColor = (tag) => {
  const config = getTagConfig(tag);
  return config.color;
};

export const getTagIcon = (tag) => {
  const config = getTagConfig(tag);
  return config.icon;
};